import React, { useMemo, useState, useContext } from 'react';
import AppContext from '../../../../../App/AppContext';
import { moment } from 'moment';
import { Grid, FormLabel, Breadcrumbs } from '@material-ui/core';
import { TextBox } from './../../../../../Core/FormInput';
import { Link } from 'react-router-dom';
import NestedGijgoGrid from './../../../../../Core/Controls/GijgoGrid/nestedGijgoGrid';
import BreadCrumbs from './../../../../../Core/Controls/Breadcrumb/index';
import formatters from '../../../../../Core/Grid/inputFormatter';
import CommonGijgoGrid from './../../../../../Core/Controls/GijgoGrid/index';
import ReportGijgoGrid from '../../GijgoForReportsScreen';
import DialogComp from '../../../../../Core/Modal/dialogModal';
import MotHistoryScreen from '../../MotHistoryScreen';
import ReactDOM from 'react-dom';
import { getReportsSalesDropdownsResolveData } from '../../../../../Core/Service/reportService';
import { VehicleNotes } from '../VehicleNotes';
import UsedNotesModal from '../../../dashboard/UsedSalesDashboard/WorkFlow/JobNotes';
var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
let addCommas = (val) => {
    return val ? `£${val.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}` : '£0.00';
};

const baseColumns = [
    { title: 'Reg Number', field: 'rn', width: 100, sortable: true },
    {
        title: 'Vehicle Description',
        field: 'vd',
        width: 250,
        sortable: true,

        cssClass: 'text-center'
    },
    { title: 'VSB No', field: 'sn', width: 80, sortable: true },
    {
        title: 'Invoice Date',
        field: 'ivd',
        width: 100,
        sortable: true,

        renderer: function (value, record) {
            return formatters.MonthShortFormatter(value);
        }
    },
    {
        title: 'In Stock',
        field: 'isd',
        width: 120,
        sortable: true,

        renderer: function (value, record) {
            return formatters.MonthShortFormatter(value);
        }
    },
    {
        title: 'RegDate',
        field: 'rd',
        width: 120,
        sortable: true,

        renderer: function (value, record) {
            return formatters.MonthShortFormatter(value);
        }
    },
    {
        title: 'Mileage',
        field: 'm',
        width: 80,

        sortable: true
    },
    { title: 'Status', field: 'acs', width: 50, sortable: true },
    { title: 'Q', field: 'qv', width: 40, sortable: true },

    {
        title: 'VAT Price',
        field: 'va',
        width: 120,
        align: 'right',
        sortable: true,

        renderer: function (value, record) {
            return addCommas(value);
        }
    },

    {
        title: 'Recon',
        field: 'rc',
        width: 90,
        sortable: true
    },
    {
        title: 'Age',
        field: 'age',
        width: 90,
        sortable: true
    },

    {
        title: 'Model Code',
        field: 'mdc',
        width: 90,
        sortable: true,
        isDropDown: true,
        listIdFromAPIResponse: 'modelRecords',
        dropDownValueField: 'name',
        dropDownLableField: 'name'
    },
    {
        title: 'Franchise',
        field: 'fn',
        width: 70,
        sortable: true,
        isDropDown: true,
        listIdFromAPIResponse: 'franchiseRecords',
        dropDownValueField: 'name',
        dropDownLableField: 'name'
    },
    {
        title: 'Selling Branch',
        width: 70,
        sortable: true,
        field: 'bn',
        isDropDown: true,
        listIdFromAPIResponse: 'branchList',
        dropDownValueField: 'name',
        dropDownLableField: 'name'
    }
];

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'Sales', active: true },
    { name: 'Used Vehicle Stock', active: true }
];

const UsedVehicleStock = (props) => {
    const { portalSettings } = useContext(AppContext);
    const [state, setState] = useState({ showMotHistory: false, handleVehicleNotes: false, records: {} });

    const regNumberRendrer = (field) => (value, record) => {
        if (!portalSettings?.portalSettingDisplayMOTHistory) {
            return value;
        }
        const spn = document.createElement('span');
        const lnk = (
            <Grid
                onClick={() => setState((st) => ({ ...st, showMotHistory: true, regNo: record?.rn, FranchiseCode: record?.franchiseCode }))}
                style={{ cursor: 'pointer' }}
            >
                {value}
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };
    const HandelNotesModal = (value = {}) => {
        setState((st) => ({
            ...st,
            handleVehicleNotes: !st.handleVehicleNotes,
            records: { sn: value.sn, vd: value.vd },
            selectedStockID: value?.usedStockID || null
        }));
    };

    const editButton = (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container alignItems="center">
                <div>
                    {value}
                </div>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const columns = useMemo(() => {
        const tempCols = [...baseColumns];

        let regNumberCol = tempCols.find((element) => element.field === 'rn');
        let StockCol = tempCols.find((k) => k.field === 'sn');

        if (regNumberCol) {
            regNumberCol.renderer = regNumberRendrer({});
        }

        if (StockCol) {
            StockCol.renderer = editButton;
        }

        return tempCols;
    }, []);
    const search = window.location.search;
    const params = new URLSearchParams(search);
    let PramFN = params.get('fn') || '';
    let PramBN = params.get('bn') || '';
    let PramMDC = params.get('mdc') || '';

    const baseUrl = `Sales/UsedVehicleStock`;
    return (
        <div className="report-screen-container">
            <BreadCrumbs crumbs={crumbs} />
            <Grid container>
                <Grid container>
                    <ReportGijgoGrid
                        dataConverter={(res) => ({
                            records: res?.data?.list,
                            total: res?.data?.total
                        })}
                        columns={columns}
                        getUrl={baseUrl}
                        displayPagination={true}
                        FilterdParamsValues={{ fn: PramFN, bn: PramBN, mdc: PramMDC }}
                        downloadName="Used Vehicle Stock"
                        dropDownListProvider={getReportsSalesDropdownsResolveData}
                    />
                </Grid>
            </Grid>
            {portalSettings?.portalSettingDisplayMOTHistory && state.showMotHistory && (
                <DialogComp title="MOT History" onClose={() => setState((st) => ({ ...st, showMotHistory: false }))} maxWidth="md" fullWidth overflow={'auto'}>
                    <MotHistoryScreen regNo={state.regNo} FranchiseCode={state.FranchiseCode} hideSeachText={true} />
                </DialogComp>
            )}
            {state.handleVehicleNotes && (
                <UsedNotesModal
                    title={`Vehicle Notes -${state.records.sn}`}
                    stockID={state.selectedStockID}
                    onClose={HandelNotesModal}
                    onNotesAdded={HandelNotesModal}
                />
            )}
        </div>
    );
};

export default UsedVehicleStock;
